import { ref } from 'vue';
import { Invoice } from '@/invoice';

const multipleInvoices = ref<Invoice[]>([]);

export function useMultipleInvoices() {
  return {
    multipleInvoices,
  }
}
